export const LOGO_SIZE = {minWidth: 300, minHeight: 300};
